import React from "react";
import { IoCloseSharp } from "react-icons/io5";

const CommonModal = ({ text, handleCloseShowModel, handleDelete,handleChangeStatus }) => {
  return (
    <div
      className="relative z-10"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 modal--popupservice">
              <div className="">
                <div className="pophead flex justify-between items-center mb-[10px]">
                  <h2 className="font-semibold text-[20px]">
                    Are you sure you want to {text}
                  </h2>
                  <div className="close cursor-pointer text-[20px]">
                    <IoCloseSharp
                      onClick={
                        handleCloseShowModel
                      } /*onClick={e=>{setshowCategoryDeleteModal(false); setActiveActionDropdown('') } }*/
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 gap-[10px] justify-end">
              {text === "delete this User" ? (
                <button
                  onClick={handleDelete}
                  type="button"
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                >
                  Delete
                </button>
              ) : text === "activate this user" ? (
                <button className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto" onClick={handleChangeStatus}>Activate User</button>
              ) : (
                <></>
              )}

              <button
                type="button"
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                // onClick={e=>{setshowCategoryDeleteModal(false); setActiveActionDropdown('') } }
                onClick={handleCloseShowModel}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonModal;
